<mat-form-field>
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [formControl]="unitSizeControl"
    [matAutocomplete]="auto"
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayUnitSize"
    (optionSelected)="update()">

    <mat-option
      *ngFor="let unitSize of filteredUnitSizes | async"
      [value]="unitSize">
      {{ unitSize.name }}
    </mat-option>

  </mat-autocomplete>
</mat-form-field>
